<template>
    <div>
        <page-header :ecnu="$organization==='ecnu'"></page-header>
        <div class="privacy">
            <div class=" page-container" v-html="statement"></div>
        </div>
    </div>
</template>

<script>
import {mapState} from "vuex";
import PageHeader from "../components/page-header.vue";

export default {
    name: "privacy",
    components: {PageHeader},
    computed: {
        ...mapState(['preset']),
        statement() {
            return this.preset.app ? this.preset.app.privacy : '';
        }
    },
}
</script>

<style scoped lang="scss">
.privacy {
    background-color: #f8f8f8;
    padding: 20px;
    border-top: 1px solid #eee;
}
</style>
